import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_nNyPgISvnXad: {
	id: 'prd_nNyPg2DEV2ISvnXad'
	ident: 'prd_nNyPgISvnXad'
	sku: 'simple_premium_4w_9_99_4w_44_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: 1
			price_id: 'prc_Zgciq2DEV2rmnbfK0'
			amount: 44
			amount_usd: 9.99
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 9.99
			discount: 34.01
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: null
			price_id: 'prc_XVxJi2DEV2NkwvUqT'
			amount: 44
			amount_usd: 44
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_nNyPgISvnXad, SubscriptionProduct>
const prd_nNyPgISvnXad = { ident: 'prd_nNyPgISvnXad' } as typeof _prd_nNyPgISvnXad

export default prd_nNyPgISvnXad
